import clsx from "clsx";
import React, { HTMLAttributes } from "react";
import { useTheme } from "../../hooks";
import { TableThemeType } from "../../types";
import { TableHeadStyled } from "./TableStyles";

export type TableHeadProps = HTMLAttributes<HTMLTableSectionElement> & {
  /** className to apply */
  className?: string;
  /** overrideable styles */
  styles?: TableThemeType;
};

const TableHead: React.FC<React.PropsWithChildren<TableHeadProps>> = ({
  children,
  className,
  styles = {},
  ...rest
}) => {
  const { Theme } = useTheme();
  const StylesOverride: TableThemeType = { ...Theme.table, ...styles };

  return (
    <TableHeadStyled className={clsx("best-table-head", className)} styles={StylesOverride} {...rest}>
      {children}
    </TableHeadStyled>
  );
};

export default TableHead;
